import { Component, Input } from '@angular/core';

type ApplicationInformation = { createdAt: Date; source: string | null | undefined };

@Component({
    selector: 'app-application-information-card',
    templateUrl: './application-information-card.template.html',
    styleUrls: ['./application-information-card.style.scss'],
})
export class ApplicationInformationCardComponent {
    @Input() applicationInformation: ApplicationInformation;

    isLoading = false;
}
